<template>
  <b-modal centered hide-footer hide-header v-model="isShow" no-close-on-backdrop>
    <div class="text-center p-3">
      <b-spinner class="align-middle "></b-spinner>
      <div class="mt-2">Please wait a few moment… </div>
      <div>loading a lot of data… </div>
    </div>

  </b-modal>
</template>
<script>
export default {
  props: {},
  components: {},
  name: "Inventory",
  data() {
    return {
      isShow: false,
    };
  },
  methods: {
    show() {
      this.isShow = true;
    },
    hide() {
      this.isShow = false;
    },
  },
};
</script>
<style scoped lang="scss"></style>
